import React, { FunctionComponent } from 'react';

import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';

export interface ILoadingSpinnerProps {
  isHideLabel?: boolean;
  label?: string;
}

export const LoadingSpinner: FunctionComponent<ILoadingSpinnerProps> = (
  props: ILoadingSpinnerProps
) => {
  return (
    <Box sx={{ padding: 5, textAlign: 'center' }}>
      <CircularProgress
        sx={{ marginBottom: '10px' }}
      />
      {!props.isHideLabel && (
        <Typography variant='body1'>
          {props.label || 'Loading data...'}
        </Typography>
      )}
    </Box>
  );
};
